import React, { useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/react-hooks";
import Toggle from "react-toggle";
import "react-toggle/style.css"
import { USER } from "../../core/queries";
import { UPDATE_MONEY_SETTINGS } from "../mutations";
import WhiteBox from "../../core/components/WhiteBox";
import { createErrorObject } from "../../core/forms";

const MoneySettingsForm = props => {
  /**
   * An interface for letting a user modify their money settings.
   */

  const { user } = props;
  const loading = Object.keys(user).length === 0;

  const [errors, setErrors] = useState({
    showAccountSummaries: "", general: ""
  });

  const [updateMoneySettings] = useMutation(UPDATE_MONEY_SETTINGS, {    
    onError: ({graphQLErrors}) => {
      setErrors(createErrorObject(errors, graphQLErrors));
    },
    onCompleted: () => setErrors("")
  });

  if (loading) {
    return <WhiteBox loading={true} />
  }

  const accountSummariesToggled = e => {
    const showSummaries = e.target.checked;
    updateMoneySettings({
      variables: {
        showAccountSummaries: showSummaries
      },
      optimisticResponse: {
        updateMoneySettings: {
          __typename: "updateMoneySettingsMutation",
          user: {
            __typename: "UserType", showAccountSummaries: showSummaries
          }
        }
      },
      update: (proxy) => {
        let newData = proxy.readQuery({ query: USER});
        newData.user.showAccountSummaries = showSummaries;
        proxy.writeQuery({ query: USER, data: newData});
      }
    })
  }

  return (
    <WhiteBox className="basic-settings-form">
      <h2>Money Settings</h2>

      {errors.general && <div className="general-error error">{errors.general}</div>}
      {errors.showAccountSummaries && <div className="error">{errors.showAccountSummaries}</div>}

      <div className="inputs">
        <div className="input toggle-input">
          <Toggle
              id="trendline"
              checked={user.showAccountSummaries}
              onChange={accountSummariesToggled}
          />
          <label htmlFor="trendline">Show Summary Trendlines</label>
        </div>
      </div>
    </WhiteBox>
  )
}

MoneySettingsForm.propTypes = {
  user: PropTypes.object.isRequired
}

export default MoneySettingsForm;